import { atom } from 'jotai'

import { exists } from '~/utils'

import { tabulationResultAtom } from './queryAtoms'

export const isTabulatedAtom = atom((get) => exists(get(tabulationResultAtom)))
